import { render, staticRenderFns } from "./ModeleDistribute.vue?vue&type=template&id=61f629a0&"
import script from "./ModeleDistribute.vue?vue&type=script&lang=js&"
export * from "./ModeleDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports